import { render } from "./SolicitacaoListaView.vue?vue&type=template&id=758a0a3b"
import script from "./SolicitacaoListaView.vue?vue&type=script&lang=js"
export * from "./SolicitacaoListaView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__